import Footer from "./Footer";
import Header from "./Header";
import Works from "./Works";

const Portfolio = () => {
    return ( 
        <div>
            <Header home={false} />
            <Works />
            <Footer />
        </div>
     );
}
 
export default Portfolio;